import apiFetch from './client';

export interface CreateMisuseReportRequest {
  spotId: string;
  licensePlate: string;
  photoUrl?: string;
  notes?: string;
}

export interface CreateMisuseReportResponse {
  id: string;
  notifiedCount: number;
}

export interface RecentMisuseReport {
  id: string;
  spotId: string;
  spotCode: string;
  licensePlate: string;
  photoUrl: string | null;
  notes: string | null;
  createdAt: string;
  reporterFirebaseUid: string;
}

export const misuseReportKeys = {
  all: ['misuse-reports'] as const,
  recent: (condominiumId: string) => [...misuseReportKeys.all, 'recent', condominiumId] as const,
};

export async function createMisuseReport(
  request: CreateMisuseReportRequest,
): Promise<CreateMisuseReportResponse> {
  return apiFetch<CreateMisuseReportResponse>('/spot-misuse-reports', {
    method: 'POST',
    body: JSON.stringify(request),
  });
}

export async function getRecentMisuseReport(
  condominiumId: string,
): Promise<RecentMisuseReport | null> {
  const data = await apiFetch<{ report: RecentMisuseReport | null }>(
    `/spot-misuse-reports/recent?condominiumId=${encodeURIComponent(condominiumId)}`,
  );
  return data?.report ?? null;
}

export type MisuseReportResolution = 'WILL_REMOVE' | 'ALREADY_RESOLVED';

export async function resolveMisuseReport(
  reportId: string,
  resolution: MisuseReportResolution,
  reason?: string,
): Promise<void> {
  await apiFetch(`/spot-misuse-reports/${encodeURIComponent(reportId)}/resolve`, {
    method: 'PUT',
    body: JSON.stringify({
      resolution,
      ...(reason ? { reason } : {}),
    }),
  });
}
